import * as t from 'io-ts';

import {makeApiSerializableType, makeApiType, makeEnumRuntimeType} from '../api/apiTypes';
import {RBusinessHours} from './businessHoursModel';

/*
 * Runtime type.
 */

export enum AnswersSortOrdersEnum {
  ALPHABETICAL = 'alphabetical',
  CUSTOM = 'custom',
  DATE_CREATED = 'date_created',
}

export const RTeamPreferencesBusinessHours = t.readonly(
  t.intersection([
    RBusinessHours,
    t.type({
      hasUpdateError: t.union([t.undefined, t.boolean]),
    }),
  ]),
);

const RTeamPreferencesDirty = t.readonly(
  t.type({
    answersSortOrder: makeEnumRuntimeType(AnswersSortOrdersEnum),
    isTrial: t.boolean,
    trialEndDate: t.union([t.Integer, t.undefined]),
    businessHours: RTeamPreferencesBusinessHours,
  }),
);

/*
 * Type.
 */

export interface TeamPreferencesBusinessHours extends t.TypeOf<typeof RTeamPreferencesBusinessHours> {}
export interface TeamPreferencesModel extends t.TypeOf<typeof RTeamPreferencesDirty> {}
export const RTeamPreferences = t.clean<TeamPreferencesModel>(RTeamPreferencesDirty as any);

/*
 * IO methods.
 */

export function parseTeamBusinessHoursPreferences(src: any): TeamPreferencesBusinessHours {
  return {
    ...src,
  };
}

export function parseTeamPreferences(src: any): TeamPreferencesModel {
  return {
    answersSortOrder: src.cannedResponseSortOrder,
    isTrial: Boolean(src.isTrial),
    trialEndDate: src.trialEndDate || undefined,
    businessHours: parseTeamBusinessHoursPreferences(src.businessHours),
  };
}

export function serializeTeamPreferences(teamPreferences: TeamPreferencesModel) {
  return {
    answersSortOrder: teamPreferences.answersSortOrder,
  };
}

/*
 * API type.
 */

export const ApiTeamPreferences = makeApiSerializableType(
  'teamPreferences',
  RTeamPreferences,
  parseTeamPreferences,
  serializeTeamPreferences,
);

export const ApiTeamPreferencesBusinessHours = makeApiType(
  'teamPreferencesBusinessHours',
  RTeamPreferencesBusinessHours,
  parseTeamBusinessHoursPreferences,
);
